<script>
export default {
  functional: true,

  props: {
    value: {
      type: Number,
      default: 0
    }
  },

  render(h, { data, props, utilStyles }) {
    return (
      <div {...data}>
        <el-row
          type="flex"
          gutter={16}
          class={utilStyles.textSecondary}
          style={{ flexWrap: 'wrap' }}
        >
          <el-col span={null} xs={24} style={{ flex: '1' }}>
            น้ำหนักทองรวม
          </el-col>
          <el-col span={null} xs={24} style={{ textAlign: 'right' }}>
            {props.value} บาท
          </el-col>
        </el-row>
      </div>
    )
  }
}
</script>

<style
  src="@/assets/scss/modules/utilities.module.scss"
  lang="scss"
  module="utilStyles"
></style>
